/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaStockOutboundOrderSkuStatisticsInfoVo } from './KoreaStockOutboundOrderSkuStatisticsInfoVo';
import {
    KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON,
    KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSONTyped,
    KoreaStockOutboundOrderSkuStatisticsInfoVoToJSON,
    KoreaStockOutboundOrderSkuStatisticsInfoVoToJSONTyped,
} from './KoreaStockOutboundOrderSkuStatisticsInfoVo';

/**
 * 
 * @export
 * @interface ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo
 */
export interface ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    message?: string;
    /**
     * 
     * @type {Array<KoreaStockOutboundOrderSkuStatisticsInfoVo>}
     * @memberof ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo
     */
    data?: Array<KoreaStockOutboundOrderSkuStatisticsInfoVo>;
}

/**
 * Check if a given object implements the ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo interface.
 */
export function instanceOfResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo(value: object): value is ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo {
    return true;
}

export function ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON(json: any): ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo {
    return ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoFromJSONTyped(json, false);
}

export function ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(KoreaStockOutboundOrderSkuStatisticsInfoVoFromJSON)),
    };
}

export function ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoToJSON(json: any): ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo {
    return ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoToJSONTyped(json, false);
}

export function ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVoToJSONTyped(value?: ResponseListKoreaStockOutboundOrderSkuStatisticsInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(KoreaStockOutboundOrderSkuStatisticsInfoVoToJSON)),
    };
}

